import AnimationPlayer from "@/components/AnimationPlayer/AnimationPlayer";
import { OptionsTopfiGraphicsType } from "@/types/OptionType";
import React from "react";
import styles from "./RecipeTopfi.module.scss";
import { Button } from "@/components/Global/Button/Button";
import { useGlobalContext } from "@aleksundshantu.com/aunds-utils-react/contexts";

function RecipeTopfi({
  topfiGraphics,
  recipe_topfi_text,
  name = "Topfi-Rezept",
  activateButton = false,
  onActivate,
  recipeTitle = "",
}: {
  topfiGraphics: OptionsTopfiGraphicsType;
  recipe_topfi_text?: string;
  name?: string;
  activateButton?: boolean;
  buttonType?: "intro" | "outro";
  onActivate?: () => void;
  recipeTitle?: string;
}) {
  const topfiElement =
    topfiGraphics &&
    topfiGraphics.elements &&
    topfiGraphics.elements.find((el) => el.name === name);

  const content =
    recipe_topfi_text || (topfiElement && topfiElement?.content) || "";
  const { getLabel } = useGlobalContext();

  return (
    <figure className={styles.topfi + " topfi"}>
      {topfiElement && topfiElement.svg_animation && (
        <AnimationPlayer url={topfiElement.svg_animation.url} autoplay={true} />
      )}

      {activateButton ? (
        <Button
          type="primary"
          href="#"
          target={""}
          onClick={() => {
            onActivate?.();
          }}
          aria-label={getLabel(
            "aria_label_cooking_mode_button",
            "Kochmodus für Rezept $$title starten",
          ).replace("$$title", recipeTitle)}
          dangerously
          className="start-btn"
        >
          {content}
        </Button>
      ) : content ? (
        <figcaption
          className={styles.text}
          dangerouslySetInnerHTML={{ __html: content }}
        />
      ) : null}
    </figure>
  );
}

export default RecipeTopfi;
